import { itemStyles } from './StatusBarItem';
import Button from '../../Button';
import React from 'react';
import styled, { css } from 'styled-components';
const Wrapper = styled(Button) `
  ${itemStyles}
  border-radius: 0;
  ${({ $active }) => $active &&
    css `
      background: rgba(0, 0, 0, 0.1);
    `}
`;
const StatusBarDropdown = ({ className, onClick, children, active, }) => {
    return (React.createElement(Wrapper, { onClick: onClick, className: className, type: "button", "$active": active }, children));
};
export default StatusBarDropdown;
